import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getHasUnmatchedCards = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.hasUnmatchedCards;
  }
);
